<template>
  <Row>
    <Col cols="12">
      <SitesHeading :username="username" />
    </Col>
    <Col cols="12">
      <Card outlined>
        <Row justify="end">
          <Col cols="12 col-sm-6 col-md-4">
            <TextField
              type="text"
              :placeholder="lc.searchPlaceholder"
              append-icon="$objects-magnify-outline"
              v-model="searchQuery"
            />
          </Col>
        </Row>
        <LoadingArea class="my-3" :displayContent="!loading">
          <template #loading>
            <Row>
              <Col cols="12">
                <SkeletonLoader class="my-2" type="image" />
                <SkeletonLoader class="my-2" type="image" />
                <SkeletonLoader class="my-2" type="image" />
              </Col>
            </Row>
          </template>
          <Row v-if="sites.length">
            <Col cols="12" v-for="site in sites" :key="site.id">
              <SiteCard :site="site" />
            </Col>
          </Row>
          <Row class="pt-6" v-else-if="searchQuery">
            <Col cols="12">
              <span
                class="text-paragraph-1 font-weight-medium"
                v-text="lc.emptyResult.replaceValues({ searchQuery })"
              />
            </Col>
          </Row>
        </LoadingArea>
      </Card>
    </Col>
    <Col cols="12" v-if="meta && meta.totalPages > 1">
      <Row justify="end">
        <Pagination
          :length="meta.totalPages"
          :totalVisible="7"
          :page="meta.currentPage"
          @input="changePage"
        />
      </Row>
    </Col>
  </Row>
</template>

<script>
import useSites from '@/composables/api/useSites'
import { computed, unref, watch } from 'vue'
import { Row, Col, Card, TextField, Pagination, LoadingArea, SkeletonLoader } from '@locaweb/design-system-vue'
import SitesHeading from '@/views/site/components/SitesHeading.vue'
import SiteCard from '@/views/site/components/SiteCard'
import { authStore } from '@/store/auth'
import useDebouncedRef from '@/composables/useDebouncedRef'

export default {
  name: 'SiteListView',
  components: {
    Row,
    Col,
    SitesHeading,
    Card,
    TextField,
    SiteCard,
    Pagination,
    LoadingArea,
    SkeletonLoader
  },
  setup () {
    const searchQuery = useDebouncedRef()
    const currentUser = authStore()
    const { data, meta, execute: executeFetch, loading } = useSites()

    const username = computed(() =>
      currentUser.userName
    )

    const sites = computed(() =>
      unref(data) || []
    )

    const changePage = async (page) => {
      await executeFetch({ query: unref(searchQuery), page })
    }

    watch(searchQuery, async (query) => {
      await executeFetch({ query, page: 1 })
    })

    return { username, searchQuery, executeFetch, changePage, sites, meta, loading }
  },
  computed: {
    lc () {
      return this.$lc('site.list')
    }
  }
}
</script>
